import { HTMLAttributes, useEffect, useState } from 'react';
import { trpc } from '@web/lib/trpc';

import { MessageAPI } from '@shared/types';

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@web/components/ui/popover';
import { ReplySuggestions } from './reply-suggestions';
import { Spinner } from '@web/components/ui/spinner';

export function SuggestionsPopover({
  children,
  message,
  onSelectReply,
}: HTMLAttributes<typeof Popover> & {
  message: MessageAPI;
  onSelectReply?: (message: { uuid: string; content: string }) => void;
}) {
  const { mutateAsync: getMessageSuggestions } =
    trpc.messaging.getMessageSuggestions.useMutation();

  const [suggestionsOpen, setSuggestionsOpen] = useState(false);

  useEffect(() => {
    if (suggestionsOpen)
      void getMessageSuggestions({
        messageId: message.id,
        contactId: message.contactId,
      });
  }, [message, getMessageSuggestions, suggestionsOpen]);

  const suggestions = message.replySuggestions;

  return (
    <Popover open={suggestionsOpen} onOpenChange={setSuggestionsOpen}>
      <PopoverTrigger className="w-full text-left">{children}</PopoverTrigger>

      <PopoverContent side="right" className="">
        {suggestions.length > 0 ? (
          <ReplySuggestions
            suggestions={suggestions}
            onSelectReply={(reply) => {
              onSelectReply?.(reply);
              setSuggestionsOpen(false);
            }}
          />
        ) : (
          <div className="h-20">
            <Spinner />
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
